import React from 'react';
import { Pencil, Check } from 'lucide-react';

export const TourMockReview: React.FC = () => {
  return (
    <div className="w-full bg-white rounded-xl border border-border shadow-lg overflow-hidden aspect-video relative group">
      <div className="p-6 opacity-40 blur-[1px] group-hover:blur-0 transition-all duration-500">
        <div className="h-4 w-1/3 bg-slate-200 rounded mb-4"></div>
        <div className="h-2 w-full bg-slate-100 rounded mb-2"></div>
      </div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-2xl border border-border p-4 w-64">
          <div className="flex justify-between items-center mb-3">
            <span className="text-xs font-bold text-muted uppercase">Editando Ação</span>
            <Pencil size={12} className="text-muted" />
          </div>
          
          <div className="bg-subtle p-2 rounded border border-border mb-3 text-sm text-ink">
            Atualizar deck de vendas <span className="bg-primary/20 text-primary px-1 rounded">com números Q3</span>
          </div>

          <div className="flex gap-2">
            <button className="flex-1 bg-primary text-white text-xs font-bold py-2 rounded-lg flex items-center justify-center gap-1">
              <Check size={12} /> Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};